import { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import PageHeader from "../../../../../../../components/PageHeader";
import useRoutePlant from "../../../../../../../hooks/useRoutePlant";
import { getDrawingData } from "../../BOMTab/DrawingRegisterTab/api";

export default function BomPage() {
  const { drawingId } = useParams();
  const { plant } = useRoutePlant();
  const [drawing, setDrawing] = useState(null);
  const [loading, setLoading] = useState(Boolean(drawingId));
  const [error, setError] = useState("");

  useEffect(() => {
    if (!drawingId) return;
    let cancelled = false;
    setLoading(true);
    setError("");
    getDrawingData(drawingId)
      .then((data) => {
        if (!cancelled) setDrawing(data ?? null);
      })
      .catch(() => {
        if (!cancelled) setError("Failed to load drawing");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [drawingId]);

  const title = drawing?.name
    ? `${drawing.name} - Rev.(${drawing?.revision ?? drawing?.rev ?? ""})`
    : "Drawing BOM";

  const rows = drawing
    ? [
        ["Name", drawing.name],
        ["Revision", drawing.revision ?? drawing.rev],
        ["Dwg Number", drawing.dwgNumber],
        ["Title", drawing.title],
        ["Sheet", drawing.sheetNumber ? `${drawing.sheetNumber}${drawing.sheetTitle ? ` — ${drawing.sheetTitle}` : ""}` : null],
        ["Discipline", drawing.discipline],
        ["Lifecycle", drawing.lifecycle],
        ["Source", drawing.source],
        ["Project Id", drawing.projectId],
      ].filter(([, value]) => value != null && value !== "")
    : [];

  return (
    <Box>
      <PageHeader plant={plant} pageTitle={title} />
      <Box sx={{ p: 2 }}>
        {loading ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CircularProgress size={16} />
            <Typography variant="body2" color="text.secondary">
              Loading drawing…
            </Typography>
          </Box>
        ) : error ? (
          <Typography variant="body2" color="error">
            {error} ({drawingId})
          </Typography>
        ) : !drawing ? (
          <Typography variant="body2" color="text.secondary">
            {drawingId ? `Drawing #${drawingId}` : "No drawing selected."}
          </Typography>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            {rows.map(([label, value]) => (
              <Typography key={label} variant="body2" color="text.secondary">
                {label}:{" "}
                <Typography component="span" variant="body2" color="text.primary">
                  {String(value)}
                </Typography>
              </Typography>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}
